import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'pejabatPenetap'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const employeeList = 'Master/PejabatPenetap/listEmployee/'
export const polaKerjaList = 'Master/PejabatPenetap/listWorkingPattern/'

export const pejabatPenetapCreate = 'Master/PejabatPenetap/create/'
export const pejabatPenetapList = 'Master/PejabatPenetap/list/'
export const pejabatPenetapDetail = 'Master/PejabatPenetap/detail/'
export const pejabatPenetapUpdate = 'Master/PejabatPenetap/update/'
export const pejabatPenetapInactive = 'Master/PejabatPenetap/inactive/'
export const pejabatPenetapActive = 'Master/PejabatPenetap/active/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}